import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { ActionablesContext } from '../../contexts/ActionablesContext'
import { NumberFieldWithLabel } from '../../components/Form/Fields'
import { BudgetContext } from './context'

export const IncomeAndBudgetAssumptions = () => {
  const { readOnly } = useContext(ActionablesContext)
  const { state: { isRetired } } = useContext(BudgetContext)

  return (
    <fieldset>
      <legend>Income and Budget</legend>
      { !isRetired &&
        <Box
          mr='2rem'
          ml='1rem'
          className='flex flex-col sm:flex-row'
        >
          <Income readOnly={readOnly} />
        </Box>
      }
    </fieldset>
  )
}

const Income = ({ readOnly }) => (
  <Box
    width='100%'
  >
    <h2>Income</h2>
    <NumberFieldWithLabel
      readOnly={readOnly}
      label='Current income (before tax)'
      name='gross_monthly_current_income'
      inputTooltip={'This includes employer contributions to retirement funds'}
    />
  </Box>
)
